import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Grid, Link, Flex, Image, Text } from "@chakra-ui/react";
import Breadcrumb from "../components/Breadcrumb";
import { printCategories, getCategoryName } from "../data/printsData";

const Prints = () => {
  const { t } = useTranslation('navigation');
  const navigate = useNavigate();
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };

  return (
    <Box
      maxWidth="1400px"
      margin="0 auto"
      padding="20px"
      paddingTop={{ base: "80px", md: "20px" }}
      pr="5%"
      pl="5%"
    >
      {/* Breadcrumb */}
      <Box mb={6}>
        <Breadcrumb
          items={[
            { label: t('breadcrumbs.work'), href: getLocalizedPath('/') },
            { label: t('breadcrumbs.prints') }
          ]}
        />
      </Box>

      <Grid
        templateColumns={{ base: "1fr", md: "1fr 1fr" }}
        gap={5}
      >
        {printCategories.map((category) => (
          <Link
            key={category.id}
            onClick={() => navigate(getLocalizedPath(`/prints/${category.slug}`))}
            _hover={{ textDecoration: "none" }}
            width="100%"
            cursor="pointer"
          >
            <Flex
              flexDirection="column"
              alignItems="center"
              width="100%"
            >
              <Flex
                width="100%"
                textAlign="center"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
              >
                <Image
                  src={category.coverImage}
                  alt={getCategoryName(category, currentLanguage)}
                  maxH={{ base: "400px", md: "500px", lg: "600px" }}
                  width="100%"
                  objectFit="contain"
                  loading="lazy"
                />
                <Text
                  fontSize="xl"
                  textDecoration="underline"
                  mt={2}
                >
                  {getCategoryName(category, currentLanguage)}
                </Text>
              </Flex>
            </Flex>
          </Link>
        ))}
      </Grid>
    </Box>
  );
};

export default Prints;
